import { NodeSelection, } from 'prosemirror-state';
import { GapCursor } from '../gapcursor/index.js';
export const captureBackspaceFromAfter = (state, dispatch) => {
    var _a;
    const { selection } = state;
    if (!selection.empty || selection.from === 0) {
        return false;
    }
    const isGap = selection instanceof GapCursor;
    const { from, $from } = selection;
    if (!isGap && from !== $from.start()) {
        return false;
    }
    const posBefore = isGap ? from : from - 1;
    const { nodeBefore } = state.doc.resolve(posBefore);
    if (!nodeBefore ||
        ((_a = nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type.spec.captureBackspaceFromAfter) !== null && _a !== void 0 ? _a : nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.isAtom) ===
            false) {
        return false;
    }
    const { tr } = state;
    const currentNode = tr.doc.resolve(from).node();
    if (currentNode.isTextblock && !currentNode.childCount) {
        tr.delete(posBefore, posBefore + currentNode.nodeSize);
    }
    tr.setSelection(NodeSelection.create(tr.doc, posBefore - nodeBefore.nodeSize));
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
    return true;
};
//# sourceMappingURL=captureBackspaceFromAfter.js.map